import React, { useState, useEffect } from 'react';

const FilterContentsAdd = ({ onClose, onSave, initialData, isEditMode = false }) => {
  const [modalData, setModalData] = useState({
    name: '',
    data: ''
  });

  useEffect(() => {
    if (initialData) {
      setModalData({
        name: initialData.name,
        data: initialData.data || ''
      });
    }
  }, [initialData]);

  const handleUpload = () => {
    // 실제 구현에서는 파일 업로드 로직 추가
    console.log('Upload filter data');
  };

  return (
    <div className="modal-overlay active">
      <div className="modal-container">
        <div className="modal-header">
          <h3 className="modal-title">필터 {isEditMode ? '수정' : '추가'}</h3>
          <button className="modal-close" onClick={onClose}>
            <i className="ri-close-line"></i>
          </button>
        </div>
        <div className="modal-body">
          <div className="modal-content">
            <div className="modal-form-group">
              <div className="modal-row-container">
                <div className="modal-column">
                  <label className="modal-label">필터명</label>
                  <input 
                    type="text" 
                    className="modal-input" 
                    id="filter-name" 
                    placeholder="필터명을 입력하세요"
                    value={modalData.name}
                    onChange={(e) => setModalData(prev => ({ ...prev, name: e.target.value }))}
                  />
                </div>
                <div className="modal-column">
                  <label className="modal-label">필터 데이터</label>
                  <div className="modal-import-with-button">
                    <input 
                      type="text" 
                      className="modal-input" 
                      id="filter-data" 
                      placeholder="URL"
                      value={modalData.data}
                      onChange={(e) => setModalData(prev => ({ ...prev, data: e.target.value }))}
                    />
                    <button 
                      className="modal-btn modal-btn-secondary" 
                      id="import-filter-btn"
                      onClick={handleUpload}
                    >
                      불러오기
                    </button>
                  </div>
                </div>
              </div>
              <div className="modal-data-image">
                <img src="images/filterData/filter1.png" alt="filter" />
              </div>
            </div>
          </div>
        </div>
        <div className="modal-footer">
          <button className="modal-btn modal-btn-cancel" onClick={onClose}>취소</button>
          <button className="modal-btn modal-btn-primary" onClick={() => onSave(modalData)}>확인</button>
        </div>
      </div>
    </div>
  );
};

export default FilterContentsAdd;
